import { render, staticRenderFns } from "./ProjectFlow.vue?vue&type=template&id=2212cacc&scoped=true&"
import script from "./ProjectFlow.vue?vue&type=script&lang=js&"
export * from "./ProjectFlow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFlow.vue?vue&type=style&index=0&id=2212cacc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212cacc",
  null
  
)

export default component.exports